import { RefreshIcon } from '@app/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './UpdateButton.module.scss'
import cl from 'classnames'

export const UpdateButton = ({onClick, disabled = false}) => {
	const { t } = useTranslation()

	return (
		<button onClick={onClick} className={cl('flex', 'align-items-center', 'gap-2')} style={{cursor: !disabled ? 'pointer' : 'no-drop'}} disabled={disabled}>
			<RefreshIcon className={styles.refreshIcon}/>
			<span className={cl(styles.updateText)}>{t('update_data')}</span>
		</button>
	)
}